// Numéro AVS suisse (NAVS13) : 756.XXXX.XXXX.XX
// Toujours 13 chiffres, toujours préfixé 756 (code pays), et le dernier chiffre est une clé
// de contrôle EAN-13. On peut donc repérer un chiffre mal recopié, pas seulement un mauvais
// nombre de chiffres. Source : Centrale de compensation (zas.admin.ch).

export const AVS_PLACEHOLDER = "756.0000.0000.00";

// Met en forme au fil de la saisie : on ne garde que les chiffres et on pose les points.
export function formatAvs(saisie) {
  const chiffres = String(saisie || "").replace(/\D/g, "").slice(0, 13);
  const morceaux = [chiffres.slice(0, 3), chiffres.slice(3, 7), chiffres.slice(7, 11), chiffres.slice(11, 13)];
  return morceaux.filter(Boolean).join(".");
}

export function cleAvsValide(chiffres) {
  let somme = 0;
  for (let i = 0; i < 12; i++) {
    somme += Number(chiffres[i]) * (i % 2 === 0 ? 1 : 3);
  }
  return (10 - (somme % 10)) % 10 === Number(chiffres[12]);
}

// Renvoie "" si le numéro est correct (ou vide : le champ est facultatif), sinon le motif
// du refus, en clair.
export function erreurAvs(valeur) {
  const chiffres = String(valeur || "").replace(/\D/g, "");
  if (!chiffres) return "";
  if (!chiffres.startsWith("756")) return "Un numéro AVS suisse commence toujours par 756.";
  if (chiffres.length < 13) return `Il manque ${13 - chiffres.length} chiffre(s) — le numéro AVS en compte 13.`;
  if (chiffres.length > 13) return "Le numéro AVS compte exactement 13 chiffres.";
  if (!cleAvsValide(chiffres)) return "Ce numéro n'existe pas : vérifie les chiffres, l'un d'eux a été mal recopié.";
  return "";
}
